let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("91z3t")).then(() => parcelRequire('52fcO'));